import React, { useEffect, useRef } from 'react'
import backgroundImage from "./assets/bg.gif"
import frontend from "./assets/frontend.jpg"
import backend from "./assets/backend.jpg"
import images from "./assets/images.jpeg"
import team2 from "./assets/team2.jpg"
import time from "./assets/time.jpg"
import test2 from "./assets/test2.jpg"
import docker2 from "./assets/docker2.jpg"
import tailwind from "./assets/tailwind.png"
import apiv from "./assets/apiv.jpg"
import django from "./assets/django.png"
import figma from "./assets/figma.png"
import git from "./assets/git.png"
import typescript from "./assets/typescript.png"
import html from "./assets/html.png"
import js from "./assets/js.png"
import redux from "./assets/redux.png"
import socket from "./assets/socket.png"
import drest from "./assets/drest.png"
import mui from "./assets/mui.png"
import nextjs from "./assets/nextjs.svg"
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';



function Knowledge() {
    const carouselRef = useRef(null);

    useEffect(() => {
        const glide = new Glide(carouselRef.current, {
          type: 'carousel',
          perView: 7, // Number of images per view
          gap: 15, // Gap between images
          autoplay: 2000, // Autoplay interval in milliseconds
          hoverpause: true, // Pause autoplay on hover
          breakpoints:{
            // when window width is >= 320px
            380: {
              perView: 3,
            },
            500: {
              perView: 3,
            },
            640: {
              perView: 4,
            },
            // when window width is >= 480px
            900: {
              perView: 5,
            }
          },
        });
    
        glide.mount();

        return () => {
            glide.destroy();
          };
        }, []);
      
  return (
        <div className="bg-cover bg-center h-full " style={{ backgroundImage: `url(${backgroundImage})` }}>
               
            <div className='w-full h-fit backdrop-blur-2xl bg-black/80 flex flex-col items-center justify-center'> 
            <div className="w-full flex justify-center items-center gap-2 mb-7 mt-4 ">
                    <div className="text-4xl sm:text-4xl text-white ">Skills &</div>
                    <div className="text-4xl sm:text-4xl text-white  ">Knowledge</div>
                </div>
                <div className="w-[70%] flex justify-between">
                    {/* <Slider /> */}
                    {/* <ImageSlider /> */}

                    {/* adding glide */}
                    <div ref={carouselRef} className="glide">
                        <div className="glide__track" data-glide-el="track">
                        <ul className="glide__slides">
                            <li className="glide__slide">
                            <img src={html} alt="Html" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-5">Html</div>
                            </li>
                            <li className="glide__slide">
                            <img src={js} alt="Js" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-7">Js</div>
                            </li>
                            <li className="glide__slide">
                            <img src={tailwind} alt="tailwind" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-3">Tailwind</div>
                            </li>
                            <li className="glide__slide">
                            <img src={socket} alt="socket.io" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-3">Socket.io</div>
                            </li>
                            <li className="glide__slide">
                            <img src={mui} alt="material ui" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-7">Mui</div>
                            </li>
                            <li className="glide__slide">
                            <img src={typescript} alt="Typescript" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white">TypescriptJs</div>
                            </li>
                            <li className="glide__slide">
                            <img src={redux} alt="Redux" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-4">Redux</div>
                            </li>
                            <li className="glide__slide">
                            <img src={git} alt="git" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-7">Git</div>
                            </li>
                            <li className="glide__slide">
                            <img src={nextjs} alt="next.js" className="rounded-full w-20 h-20 bg-white p-2" />
                            <div className="text-white ml-6">Next</div>
                            </li>
                            <li className="glide__slide">
                            <img src={figma} alt="figma" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-5">Figma</div>
                            </li>
                            <li className="glide__slide">
                            <img src={images} alt="Python" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-4">Python</div>
                            </li>
                            <li className="glide__slide">
                            <img src={django} alt="Django" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-5">Django</div>
                            </li>
                            <li className="glide__slide">
                            <img src={drest} alt="Django rest framework" className="rounded-full w-20 h-20 xs:w-15 xsh-15" />
                            <div className="text-white ml-7">DRF</div>
                            </li>
                        </ul>       
                        </div>
                    </div>
                </div>


                <div className='w-[85%] xs:w-[70%] h-fit grid  gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mb-[130px] pt-4'> 
                <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>      
                 <img src={frontend} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Frontend
                        </div>
                        <div className="text-center px-4 py-2">
                            <div className="text-sm text-white/70">
                                {"As a frontend developer, I specialize in creating visually appealing and user-friendly interfaces with my expertise in Css, tailwind, react, material-ui(mui) e.t.c"}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4'>  
                        <img src={backend} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Backend
                        </div>
                        <div className="text-center px-4 py-2">
                            <div className="text-sm text-white/70">
                            {"I am skilled in building secure server-side code, handling data processing, implementing algorithms with Python and Django. am also apt in developing RESTful APIs using frameworks such as Django REST Framework"}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4'>  
                        <img src={apiv} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Rest Api
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {"I can implement APIs that follow best practices. I am skilled in building endpoints, handling HTTP methods, managing authentication and authorization, and integrating third-party APIs, using Django REST Framework "}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>  
                        <img src={git} alt={"name"} className="rounded-tr-xl xs:h-[50%]  h-[40%] w-full rounded-tl-xl border-none bg-white object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Git & Github
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {" I am vast in using Git for, version control, branching, merging, and resolving conflicts. GitHub, for managing repositories, collaborating with teammates, and leveraging its features such as issues, pull requests, and code reviews."}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>  
                        <img src={docker2} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Containers(Docker)
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {"I have a solid understanding of Docker and containerization concepts. I am experienced in creating Docker images, managing containers, and deploying containerized applications to various platforms."}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>  
                        <img src={test2} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Debugging & Testing
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {" I am experienced in identifying and resolving issues, using various debugging techniques and tools. I am proficient in writing unit tests, integration tests, and end-to-end tests to validate the code and ensure its robustness."}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>  
                        <img src={time} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Time management
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {" I have developed excellent time management skills, enabling me to effectively prioritize tasks, meet deadlines, and deliver projects promptly.i adapt to changing priorities to ensure successful project completion."}</div>
                        </div>
                    </div>
                    <div className='cursor-pointer xs:w-fit h-[420px] w-full  pop-up bg-black/60 bg-opacity-80 backdrop-filter rounded-lg  mt-4 '>  
                        <img src={team2} alt={"name"} className="rounded-tr-xl xs:h-[50%] rounded-tl-xl  h-[40%] w-full border-none object-fit"/>
                        <div className='text-[#764ABC] text-center'> 
                        Team Player
                        </div>
                        <div className="text-center px-4 py-3">
                            <div className="text-sm text-white/70">
                                {"I actively engage in discussions, share knowledge and ideas, and contribute to the overall success of the team. I believe in fostering a positive and supportive team environment, where communication and cooperation are prioritized."}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default Knowledge